let watchElement = document.querySelector('#watch')

if(watchElement){

    function time() {
        let d = new Date()
        let h = (d.getHours() + d.getMinutes()/60) / 12 * 360
        let m = (d.getMinutes() + d.getSeconds()/60) / 60 * 360
        let s = (d.getSeconds() + d.getMilliseconds()/1000) /60 * 360
        watchElement.querySelector('.hands .h').style.transform = 'rotate('+h+'deg)'
        watchElement.querySelector('.hands .m').style.transform = 'rotate('+m+'deg)'
        watchElement.querySelector('.hands .s').style.transform = 'rotate('+s+'deg)'
    }
    
    time()
    setInterval(time, 10)
}